import { module as m } from 'modujs';
import gsap from 'gsap';
import {StoreSingleton} from "../../../singletons/store";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.isProcessing = false;
        this.previousLegend = null;
        this.currentLegend = this.$('legend')[0];
        this.current = this.$('item')[0];
        this.animation = null;

        // DOM
        this.dom = {};
        this.dom.r1 = document.querySelector('#home .home-presentation .r-1');
        this.dom.r2 = document.querySelector('#home .home-presentation .r-2');
        this.dom.r3 = document.querySelector('#home .home-presentation .r-3');

        // EVENTS
        this.events = {
            'click': {
                'item': '_showCurrent'
            }
        }
    }

    init() {}

    /**
     * SHOW CURRENT
     * @private
     */
    _showCurrent(e) {
        if(!e.currentTarget.classList.contains('current')) {
            this.current.classList.remove('current');
            this.current = e.currentTarget;
            this.current.classList.add('current');

            const _id = e.currentTarget.dataset.id;
            this.previousLegend = this.currentLegend;
            this.currentLegend = this.el.querySelector('.legend-item.' + _id);

            gsap.killTweensOf(this.previousLegend);
            gsap.killTweensOf(this.currentLegend);

            this.animation = gsap.timeline();
            this.animation.set(this.currentLegend, {
                yPercent: 10,
                autoAlpha: 0,
            });
            this.animation.to(this.previousLegend, {
                duration: 0.6,
                yPercent: -10,
                rotate: 0.01,
                autoAlpha: 0,
                ease: 'power4.in'
            });
            this.animation.to(this.currentLegend, {
                duration: 0.6,
                yPercent: 0,
                rotate: 0.01,
                autoAlpha: 1,
                ease: 'power4.out'
            }, 0.5);

            this.call('changePath', this.current.dataset.animation, 'Lottie', 'Home');
        }
    }

    /**
     * UPDATE LOTTIE
     * @private
     */
    updateLottie(i__data) {
        if(!StoreSingleton.isMobile) {
            if(i__data.way === "enter") {
                const _lottie = i__data.elt.el.querySelector('.current').dataset.animation;
                this.call('changePath', _lottie, 'Lottie', 'Home');
            } else if(i__data.way === "exit" && window.deadwater.scroll.direction === "down") {
                const _lottie = this.dom.r3.querySelector('.current').dataset.animation;
                this.call('changePath', _lottie, 'Lottie', 'Home');
            } else if(i__data.way === "exit" && window.deadwater.scroll.direction === "up") {
                const _lottie = this.dom.r1.querySelector('.illustration .lottie').dataset.lottieJson;
                console.log(_lottie);
                this.call('changePath', _lottie, 'Lottie', 'Home');
            }
        }
    }
}
